import React from "react";
import { classNames } from "@/core/utils/classname-utils";

export function NavBarContainer({
  className,
  children,
  ...props
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) {
  return (
    <div
      {...props}
      className={classNames(
        "flex justify-cener items-center w-full min-h-[48px] px-4 py-1 bg-zinc-900 border-b border-zinc-800",
        className ?? "",
      )}
    >
      {children}
    </div>
  );
}
